import { Link } from "react-router-dom";
import { Fire, Phone } from "@phosphor-icons/react";
import { CONTACT } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const EmergencySection = () => (
  <section data-testid="emergency-section" className="relative overflow-hidden border-t border-white/10 py-20 md:py-24">
    <div className="absolute inset-0">
      <div className="absolute inset-0 bg-panel" />
      <div className="absolute left-0 top-0 h-full w-1 bg-brand-ember" />
      <div className="absolute -left-20 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-brand-ember/10 blur-3xl" />
    </div>
    <div className="relative mx-auto max-w-[1440px] px-6 md:px-12">
      <Reveal className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div className="max-w-2xl">
          <div className="mb-4 flex items-center gap-3">
            <Fire size={18} weight="fill" className="text-brand-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-ember">Emergency · No-Heat Service</span>
          </div>
          <h2 className="font-display text-3xl font-extrabold leading-[1] tracking-tight md:text-5xl">
            No heat? Get the system diagnosed correctly.
          </h2>
          <p className="mt-5 font-body text-base leading-relaxed text-slatex-300">
            A cold snap isn't the time for guesswork. We diagnose the actual fault and get your heat back with a proper repair — not a temporary patch.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <a href={`tel:${CONTACT.phoneRaw}`} data-testid="emergency-call" className="group flex items-center justify-center gap-2 border border-brand-ember bg-brand-ember px-8 py-4 font-mono text-sm uppercase tracking-widest text-white transition-colors hover:bg-brand-ember/85">
            <Phone size={16} weight="fill" /> {CONTACT.phone}
          </a>
          <Link to="/contact" data-testid="emergency-request" className="border border-white/20 px-8 py-4 text-center font-mono text-sm uppercase tracking-widest text-white transition-colors hover:border-white/50">
            Request HVAC Service
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default EmergencySection;
